'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var eventBus = require('@nextcloud/event-bus');

var tokenElement = document.getElementsByTagName('head')[0];
var token = tokenElement ? tokenElement.getAttribute('data-requesttoken') : null;
var observers = [];
function getRequestToken() {
    return token;
}
function onRequestTokenUpdate(observer) {
    observers.push(observer);
}
// Listen to server event and keep token in sync
eventBus.subscribe('csrf-token-update', function (e) {
    token = e.token;
    observers.forEach(function (observer) {
        try {
            observer(e.token);
        }
        catch (e) {
            console.error('error updating CSRF token observer', e);
        }
    });
});

/// <reference types="@nextcloud/typings" />
var getAttribute = function (el, attribute) {
    if (el) {
        return el.getAttribute(attribute);
    }
    return null;
};
var head = document.getElementsByTagName('head')[0];
var uid = getAttribute(head, 'data-user');
var displayName = getAttribute(head, 'data-user-displayname');
var isAdmin = (typeof OC === 'undefined')
    ? false
    : OC.isUserAdmin();
function getCurrentUser() {
    if (uid === null) {
        return null;
    }
    return {
        uid: uid,
        displayName: displayName,
        isAdmin: isAdmin,
    };
}

exports.getCurrentUser = getCurrentUser;
exports.getRequestToken = getRequestToken;
exports.onRequestTokenUpdate = onRequestTokenUpdate;
//# sourceMappingURL=index.js.map
